module.exports = __webpack_public_path__ + "1dac53862c05b347995818732f66f5e2.glb";